import Api from './Api';

export default {
  login(req) {
    const api = Api.generateApiLogin();
    return api.post('account/login', req).then(res => res);
  }
};
